const getters = {
    getAdvanceTransaction(state) {
        return state.serviceRequestTransaction;
    },
    getServiceRequestTransactions(state) {
        return state.serviceRequestTransactions;
    }
}

export default getters;